package org.vreo.devicehub.features.settings.presentation.mainSettings

/**
 * Main settings state
 */
data class MainSettingsState(
    val isDeviceActive: Boolean = false,
)